import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId, scrollToTop } from "../lib/scroll";

const LINKS = [
  { label: "Work", id: "work", testid: "nav-work-link" },
  { label: "Contact", id: "contact", testid: "nav-contact-link" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goHome = (e) => {
    e.preventDefault();
    if (onHome) {
      scrollToTop();
    } else {
      navigate("/");
    }
  };

  const goSection = (e, id) => {
    e.preventDefault();
    if (onHome) {
      scrollToId(id);
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-500 ${
        scrolled
          ? "border-white/10 bg-ink/70 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 py-4 lg:px-12 lg:py-5">
        <a
          href="/"
          data-testid="header-logo"
          onClick={goHome}
          className="flex flex-col items-start leading-none"
        >
          <span className="whitespace-nowrap font-display text-xl font-extrabold uppercase tracking-tight text-white">
            Pix<span className="text-vermilion">.</span>
          </span>
          <span className="mt-1 whitespace-nowrap font-body text-[8px] font-light uppercase tracking-[0.4em] text-neutral-400 md:text-[9px]">
            Marketing
          </span>
        </a>

        <nav className="flex items-center gap-4 md:gap-8">
          {LINKS.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              data-testid={link.testid}
              onClick={(e) => goSection(e, link.id)}
              className="group relative inline-block py-2 font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-300 transition-colors hover:text-vermilion active:text-vermilion md:text-xs"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-vermilion transition-transform duration-300 group-hover:scale-x-100" />
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}